module.exports = __webpack_public_path__ + "img/driven-by-eesg.449440d3.jpg";